module.exports = __webpack_public_path__ + "img/icon-clipboard.f4965c38.svg";